
import { defineComponent, PropType, ref, watch } from "vue";
import { Rate } from "ant-design-vue";
import { displayType } from "@/types/SurveyInfo";

export default defineComponent({
  name: "RateBlock",

  components: {
    ARate: Rate,
  },

  props: {
    nameSurvey: String,
    text: String,
    index: Number,
    status: Boolean,
    type: {
      type: String as PropType<displayType | undefined>,
      required: false,
    },
  },
  emits: ["answersFields"],

  setup(props, { emit }) {
    const rateValue = ref<number>(0);

    watch(
      () => rateValue.value,
      (v: number) => {
        emit("answersFields", props.index, { rateChoiceVal: v });
      }
    );

    return {
      rateValue,
    };
  },
});
